export default "__VITE_ASSET__5bb08777__"